<p-confirmDialog key="togglemfa" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>School:</label>
	<p-dropdown
		style="margin-left: 5px"
		[disabled]="IsLoading() == true"
		[options]="lstSchool"
		[(ngModel)]="School"
		optionLabel="SchoolFullName"
		[filter]="true"
		filterBy="SchoolFullName"
		[showClear]="false"
		placeholder="Select a School"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="School">
				<div class="form-control NoBorder" style="text-align: left">
					{{ School.SchoolFullName }}
				</div>
			</div>
		</ng-template>
		<ng-template let-SchoolItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ SchoolItem.SchoolFullName }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Reset Registration:</label>
	<div class="CheckGrid">
		<input type="checkbox" class="CHK" [(ngModel)]="ResetRegistration" [disabled]="IsLoading() == true" />
		<label *ngIf="ResetRegistration == false">(Keep Existing Registration)</label>
		<label *ngIf="ResetRegistration == true">(Generate New QR Codes)</label>
	</div>

	<label>Set to:</label>
	<div class="CheckGrid">
		<input type="checkbox" class="CHK" [(ngModel)]="MFAEnabled" [disabled]="IsLoading() == true" />
		<label *ngIf="MFAEnabled == false">(Turn Off)</label>
		<label *ngIf="MFAEnabled == true">(Turn On)</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()" [disabled]="IsLoading() == true">Update</button>
	<button class="btn btn-warning SmallMarginLeft" (click)="onClose()" [disabled]="IsLoading() == true">Cancel</button>
</div>
